import { memo } from 'react';
import { Grid } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import SortableHeader from 'components/sortable_header';
import useMobile from 'hooks/use_mobile';

const ListHeader = ({ sortBy, onSortChange }) => {
  const isMobile = useMobile();

  if (isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 5 }}>
          <SortableHeader
            field="email"
            label="user.email"
            sortBy={sortBy}
            onSortChange={onSortChange}
            textAlign="left"
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <SortableHeader
            field="role"
            label="user.role"
            sortBy={sortBy}
            onSortChange={onSortChange}
            textAlign="center"
          />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="center">
          <FormattedMessage id="user.confirmed" />
        </Grid>
        <Grid size={{ xs: 1 }} textAlign="center">
          <FormattedMessage id="actions" />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default memo(ListHeader);
